<template>
    <div>
        <app-navigation/>
        <app-banner
          backgroundUrl="/home/home-header.jpeg"
          :headerButtons="headerButtons"
          backgroundSize="cover"
          title="Contact Us"
          description="Have questions about our epidemic intelligence platform or interested in partnering with EPIWATCH®? We're ready to explore how we can work together to transform global health security."
          />
          <div class="white-section-text">
            <div :class="mobile ? 'section-title-mobile' : 'section-title'">Our Vision. Our Mission.</div>
            <p class="section-text">Let's collaborate on building a safer, healthier world. Connect with our team to discuss how EPIWATCH's AI-powered health intelligence can support your goals.</p>

          </div>
        <ContactForm/>
        <app-footer/>
    </div>
</template>

<script>
// @ is an alias to /src
import AppNavigation from '@/components/AppNavigation.vue'
import AppFooter from '@/components/AppFooter.vue';
import AppBanner from "@/components/AppBanner.vue";
import ContactForm from '../components/ContactForm.vue';
export default {
  name: 'Contact',
  components: {
      AppNavigation,
      AppBanner,
      AppFooter,
      ContactForm
  },
  data: () => ({
      mobile: null,
      windowWidth: null,
      emailed: false,
      valid: false,
      headerButtons:[],
     
    }),
  created() {
      window.addEventListener('resize', this.checkScreen);
      this.checkScreen();
    },
    destroy() {
      window.removeEventListener('resize', this.checkScreen)
    },
    mounted() {
      this.checkScreen();
    },
    methods: {
      checkScreen() {
        this.windowWidth = window.innerWidth;
        if (this.windowWidth <= 1000) {
          this.mobile = true;
        } else {
          this.mobile = false;
        }
      
        return;
      },
      selectService(id) {
        this.activeService = id;
        return;
      }
    }
}
</script>

<style>
.v-btn__content {
  width: 100%;
  white-space: normal;
}

a {
  text-decoration: none;
}

.text-field-dense-label-top {
  font-size: 1.125em !important;
}
</style>